import { ObservableValueProducerBase } from "./ChainableValueProducer";

export class EmptyProducer extends ObservableValueProducerBase<void> {
    protected async beginListening(): Promise<void> {
        // noop
    }

    protected async stopListening(): Promise<void> {
        // noop
    }

    protected async getCurrentValue(): Promise<void> {
        // noop
    }
}
